module.exports = __webpack_public_path__ + "img/circle.953c9ca0.svg";